import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=7801f364&"
import script from "./Buttons.vue?vue&type=script&setup=true&lang=js&"
export * from "./Buttons.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=7801f364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports